import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import React from 'react';
import Box from '@mui/material/Box';
import { brand } from '../../templates/shared-theme/themePrimitives';

const FeatureCard = ({ icon_url, title, content }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
      p: 2,
      margin: '0 auto', // Center the card horizontally
      maxWidth: 480,
      height: '100%', // Ensure the card takes the full height
    }}
  >
    <Box
      component="img"
      src={icon_url}
      alt={title}
      sx={{
        width: 156,
        height: 156,
        mb: 2,
      }}
    />
    <Typography variant="h4" fontWeight="bold" sx={{ color: brand[500], fontFamily: 'League Spartan, sans-serif' }}>
      {title}
    </Typography>
    <Typography variant="body2" sx={{ fontSize: '1.1rem', fontFamily: 'Montserrat Classic, sans-serif' }}>
      {content}
    </Typography>
  </Box>
);

export default function HomeStart() {
  const features = [
    {
      icon_url: "/assets/images/services/secure.png",
      title: "Certified Platform",
      content:
        "Our Platform collaborates with National Council on Strength & Fitness (NCSF). All trainers are certified. Train with peace of mind.",
    },
    {
      icon_url: "/assets/images/services/hasslefree.png",
      title: "Hassle Free",
      content:
        "Browse hundreds of certified trainers and find your perfect match. Free to change when you are not satisfied.",
    },
    {
      icon_url: "/assets/images/services/payment.png",
      title: "Secure Payment",
      content:
        "Funds held safely by our platform and released to trainers only after the session is completed",
    },
    {
      icon_url: "/assets/images/services/appointment.png",
      title: "Flexible Schedule",
      content:
        "Book sessions that fit your schedule, anytime, anywhere. Change or cancel with ease.",
    },
  ];

  return (
    <Container
      sx={{
        pt: { xs: 10, md: 15 },
        pb: { xs: 5, md: 10 },
      }}
    >
      <Stack spacing={3} sx={{ textAlign: 'center' }}>
        <Typography variant="h2">
          Why Choose Us?
        </Typography>
      </Stack>

      <Box
        sx={{
          display: 'grid',
          my: { xs: 8, md: 10 },
          gap: { xs: 4, md: 3 },
          gridTemplateColumns: {
            xs: 'repeat(1, 1fr)',
            sm: 'repeat(2, 1fr)',
            md: 'repeat(2, 1fr)',
          },
          justifyContent: 'center',
          alignItems: 'stretch', // Ensure all items stretch to the same height
        }}
      >
        {features.map((feature, index) => (
          <FeatureCard
            key={index}
            icon_url={feature.icon_url}
            title={feature.title}
            content={feature.content}
          />
        ))}
      </Box>
    </Container>
  );
}
